module.exports = __webpack_public_path__ + "static/media/team3.0c53d5b8.png";